import { type ApolloClient, ApolloProvider as ApolloProviderOG, type NormalizedCacheObject } from "@apollo/client";
import { type ReactNode, useState } from "react";
import { useApolloClient } from "../../lib/apollo";
export type ApolloProviderProps = {
  apolloPath: string;
  apolloWsPath: string;
  rethrowError?: (error: Error) => void;
  onAuthError?: () => Promise<void>;
  enableDevTools?: boolean;
  children: ReactNode;
};
export const ApolloProvider = ({
  apolloPath,
  apolloWsPath,
  rethrowError,
  onAuthError,
  enableDevTools,
  children
}: ApolloProviderProps) => {
  const [apolloClient] = useState<ApolloClient<NormalizedCacheObject>>(useApolloClient(apolloPath, apolloWsPath, rethrowError, onAuthError, enableDevTools));
  return <ApolloProviderOG client={apolloClient} data-sentry-element="ApolloProviderOG" data-sentry-component="ApolloProvider" data-sentry-source-file="ApolloProvider.tsx">{children}</ApolloProviderOG>;
};